import '../../monitoring/dashboards/dashboard_results/dashboard_preview_results_view.js.coffee'
Customer.Users ||= {}

# TODO: Find a better way to require dashboard_preview_results_view
class Customer.Users.ProfileContentsView extends Monitoring.Views.DashboardPreviewResultsView
  template: JST['backbone/templates/customer/users/content']

  className: 'tab-pane'
  id: 'user-contents'
